import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BadgeSize } from '@capital-access/common/utils';
import { ESG_COMPONENT_KEY } from '@capital-access/esg/common';
import { ProfileType } from '@capital-access/profiles/common';

@Component({
  selector: 'ca-esg-tag',
  templateUrl: 'esg-tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EsgTagComponent {
  @Input() badgeSize: BadgeSize = BadgeSize.Xxs;
  @Input() rootCssClass = '';

  @Input() set profileType(profileType: ProfileType) {
    if (profileType === ProfileType.Institution) {
      this.tooltipText = 'institutionEsgTooltip';
    } else if (profileType === ProfileType.Fund) {
      this.tooltipText = 'fundEsgTooltip';
    } else {
      this.tooltipText = 'contactEsgTooltip';
    }
  }

  tooltipText!: string;
  localizationKey: string = ESG_COMPONENT_KEY;
}
